import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { WithLayoutType } from '@sbercloud/uikit-product-utils';
import { Typography } from '@snack-uikit/typography';
import { useMemo } from 'react';

import styles from './styles.module.scss';
import { Size } from './types';
import { getTitleTypographyProps } from './utils';

export type SectionTitleProps = WithLayoutType<{
  /** Название секции */
  title?: string;
  /** Размер шрифтов заголовка и подзаголовка */
  titleSectionSize?: Size;
}>;

export function SectionTitleCatalogMain({
  title,
  layoutType,
  titleSectionSize = 'm',
}: SectionTitleProps) {
  const titleProps = useMemo(
    () => getTitleTypographyProps({ titleSectionSize, layoutType }),
    [layoutType, titleSectionSize],
  );

  if (!title) {
    return null;
  }

  return (
    <div className={styles.sectionTitle}>
      {title && (
        <Typography {...titleProps} family="sans" className={styles.title}>
          <RichText richText={title} />
        </Typography>
      )}
    </div>
  );
}
